import React, {useEffect, useReducer, useState} from 'react';
import {useDispatch} from 'react-redux';
import {ContentAdDesktop} from 'app/styles/content';
import styled from 'styled-components';
import {formatMediumDate} from 'app/helpers/dateHelpers';
import {Helmet} from 'react-helmet-async';
import {LoadingIndicator, LOADING_MESSAGE, SIZES} from '@fupa/fupa-uikit';
import {fetchAboutDetail} from 'app/routes/about/AboutDetailPageActions';
import {AboutDetailPageReducer} from 'app/routes/about/AboutDetailPageReducer';
import {InnerHtmlText} from 'app/components/text/InnerHtmlText';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';

const ContentTotal = styled(ContentAdDesktop)`
  &&& {
    box-sizing: border-box;
    padding: ${SIZES['32']} ${SIZES['16']};
    min-height: 100vh;
  }
`;

const metaDescription = {
  'terms-of-use': 'Nutzungsbedingungen von FuPa.net',
  'privacy-policy': 'Datenschutzerklärung von FuPa.net',
};

const AboutDetailPage = () => {
  const {restoredData} = useRestoreData('AboutDetailPage');
  const {categorySlug, regionSlug} = useParams();

  const initialData = {
    isFetching: false,
    data: {},
  };
  const initialState = restoredData ?? initialData;

  useEffect(() => {
    // Hide consent message on terms-of-use, privacy policy and legal notice
    window.cmp_noscreen = true;
    return () => {
      window.cmp_noscreen = undefined;
    };
  }, []);

  const [state, dispatch] = useReducer(AboutDetailPageReducer, initialState);
  const dispatchRedux = useDispatch();

  const indexCats = ['privacy-policy', 'terms-of-use'];

  const meta = indexCats.includes(categorySlug)
    ? [
        {
          name: 'robots',
          content: 'index, nofollow',
        },
        {name: 'description', content: metaDescription[categorySlug]},
      ]
    : [
        {
          name: 'robots',
          content: 'noindex, nofollow',
        },
      ];

  const loadData = reset => {
    const componentState = reset ? initialData : state;

    return fetchAboutDetail(categorySlug, regionSlug, dispatchRedux)(dispatch, componentState);
  };
  const {isFetching, data} = state;
  useFetchData(state, loadData, 'AboutDetailPage');
  const [firstExecution, setFirstExecution] = useState(true);
  const modfiedDate = formatMediumDate(data.lastModified);

  useEffect(() => {
    // Always load new data when switching between categories
    if (!firstExecution) {
      loadData(true);
    }
    setFirstExecution(false);
  }, [categorySlug]);

  if (isFetching) {
    return (
      <ContentTotal noTabs top='4.5rem'>
        <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor={false} />
      </ContentTotal>
    );
  }

  return (
    <ContentTotal noTabs top='4.5rem'>
      <Helmet title={`${data.title}${TITLE_POSTFIX}`} meta={meta} />
      <InnerHtmlText text={data.text} />
      <div>Letzte Änderung: {modfiedDate}</div>
    </ContentTotal>
  );
};

export default AboutDetailPage;
